import { useRouter } from 'next/router';
import RegisterBox from '../../RegisterBox';
import CardList from './CardList';
import Programme from './Programme';
import ScrollCard from './ScrollCard';
import EarnMore from './EarnMore';
import UseSpecials from './UseSpecials';

export default function TabB() {
    const { locale } = useRouter();

    return (
        <>
            {['jp'].includes(locale as string) && <CardList />}
            <Programme />
            <ScrollCard />
            <EarnMore />
            <UseSpecials />
            {['kr', 'za'].includes(locale as string) && <RegisterBox />}
        </>
    );
}
